<template>
    <n-layout-header bordered class="header">
        <n-space justify="space-between" style="width: 100%">
            <n-space align="center">
                <router-link :to="backUrl" v-if="backUrl">
                    <n-button size="medium" tertiary>
                        <template #icon>
                            <n-icon size="25" color="#000000" bordered="false">
                                <arrow-back />
                            </n-icon>
                        </template>
                    </n-button>
                </router-link>
                <logo></logo>
            </n-space>
            <user-center></user-center>
        </n-space>
    </n-layout-header>

    <n-layout has-sider :position="'absolute'">
        <n-layout-sider
            bordered
            show-trigger="bar"
            collapse-mode="width"
            :collapsed-width="64"
            :width="240"
            :native-scrollbar="false"
            :collapsed="menuCollapsed"
            :on-update:collapsed="onMenuCollapsed"
            class="layout-sider"
        >
            <n-config-provider :theme-overrides="themeOverrides">
                <n-menu
                    :collapsed-width="64"
                    :collapsed-icon-size="22"
                    :options="menuOptions"
                    :default-value="menuSelected"
                    :watch-props="['defaultValue']"
                    class="side-menu"
                />
            </n-config-provider>
        </n-layout-sider>
        <n-layout-content content-style="padding: 88px 24px 24px 24px">
            <router-view></router-view>
        </n-layout-content>
    </n-layout>
</template>

<script>
import { h } from "vue";
import { RouterLink } from "vue-router";
import { Terminal, ArrowBack } from "@vicons/ionicons5";
import { NIcon } from "naive-ui";

// Components
import logo from "../navs/logo.vue";
import userCenter from "../navs/userCenter.vue";

// Override some menu properties
const themeOverrides = {
    Menu: {
        itemHeight: "52px",
        fontSize: "16px",
    },
};

export default {
    name: "dashboardLayout",
    props: {
        backUrl: {
            required: false,
        },
        menuOptions: {
            required: true,
        },
    },
    data() {
        return {
            themeOverrides,
            menuCollapsed: localStorage.getItem("menuCollapsed") === "1", // Get current menu collapse state
        };
    },
    computed: {
        menuSelected() {
            return this.$route.name; // Menu selection depends on computed property to fix active state not updating on browser back
        },
    },
    methods: {
        // Update menu collapse state
        onMenuCollapsed(value) {
            if (value) {
                localStorage.setItem("menuCollapsed", "1");
            } else {
                localStorage.setItem("menuCollapsed", "0");
            }
            this.menuCollapsed = value;
        },
    },
    components: {
        logo,
        userCenter,
        ArrowBack,
    },
};
</script>

<style scoped>
.side-menu {
    padding-top: 104px; /* 64(header height)+40(distance from first menu item to header)=104 */
}
.header {
    height: 64px; /* Height required for absolute layout positioning */
    display: flex;
    align-items: center;
    padding: 0 48px 0 30px; /* Header side padding */
    box-shadow: 0 10px 30px rgb(38 38 38 / 5%);
    z-index: 10;
    position: relative; /* Prevent shadow from being covered by sidebar */
}
.layout-sider {
    background-color: rgb(250, 250, 250);
}
</style>
